const {h} = require('./h');
function a(args, ...children) {return h('a', args, ...children)}
function abbr(args, ...children) {return h('abbr', args, ...children)}
function address(args, ...children) {return h('address', args, ...children)}
function aside(args, ...children) {return h('aside', args, ...children)}
function b(args, ...children) {return h('b', args, ...children)}
function bdi(args, ...children) {return h('bdi', args, ...children)}
function bdo(args, ...children) {return h('bdo', args, ...children)}
function blockquote(args, ...children) {return h('blockquote', args, ...children)}
function br(args, ...children) {return h('br', args, ...children)}
function button(args, ...children) {return h('button', args, ...children)}
function caption(args, ...children) {return h('caption', args, ...children)}
function code(args, ...children) {return h('code', args, ...children)}
function col(args, ...children) {return h('col', args, ...children)}
function colgroup(args, ...children) {return h('colgroup', args, ...children)}
function div(args, ...children) {return h('div', args, ...children)}
function em(args, ...children) {return h('em', args, ...children)}
function embed(args, ...children) {return h('embed', args, ...children)}
function fieldset(args, ...children) {return h('fieldset', args, ...children)}
function footer(args, ...children) {return h('footer', args, ...children)}
function form(args, ...children) {return h('form', args, ...children)}
function h1(args, ...children) {return h('h1', args, ...children)}
function h2(args, ...children) {return h('h2', args, ...children)}
function h3(args, ...children) {return h('h3', args, ...children)}
function h4(args, ...children) {return h('h4', args, ...children)}
function h5(args, ...children) {return h('h5', args, ...children)}
function h6(args, ...children) {return h('h6', args, ...children)}
function header(args, ...children) {return h('header', args, ...children)}
function hgroup(args, ...children) {return h('hgroup', args, ...children)}
function hr(args, ...children) {return h('hr', args, ...children)}
function i(args, ...children) {return h('i', args, ...children)}
function img(args, ...children) {return h('img', args, ...children)}
function input(args, ...children) {return h('input', args, ...children)}
function label(args, ...children) {return h('label', args, ...children)}
function li(args, ...children) {return h('li', args, ...children)}
function mark(args, ...children) {return h('mark', args, ...children)}
function nav(args, ...children) {return h('nav', args, ...children)}
function ol(args, ...children) {return h('ol', args, ...children)}
function optgroup(args, ...children) {return h('optgroup', args, ...children)}
function option(args, ...children) {return h('option', args, ...children)}
function p(args, ...children) {return h('p', args, ...children)}
function pre(args, ...children) {return h('pre', args, ...children)}
function progress(args, ...children) {return h('progress', args, ...children)}
function q(args, ...children) {return h('q', args, ...children)}
function s(args, ...children) {return h('s', args, ...children)}
function section(args, ...children) {return h('section', args, ...children)}
function select(args, ...children) {return h('select', args, ...children)}
function small(args, ...children) {return h('small', args, ...children)}
function span(args, ...children) {return h('span', args, ...children)}
function strong(args, ...children) {return h('strong', args, ...children)}
function sub(args, ...children) {return h('sub', args, ...children)}
function sup(args, ...children) {return h('sup', args, ...children)}
function table(args, ...children) {return h('table', args, ...children)}
function tbody(args, ...children) {return h('tbody', args, ...children)}
function td(args, ...children) {return h('td', args, ...children)}
function textarea(args, ...children) {return h('textarea', args, ...children)}
function tfoot(args, ...children) {return h('tfoot', args, ...children)}
function th(args, ...children) {return h('th', args, ...children)}
function thead(args, ...children) {return h('thead', args, ...children)}
function tr(args, ...children) {return h('tr', args, ...children)}
function u(args, ...children) {return h('u', args, ...children)}
function ul(args, ...children) {return h('ul', args, ...children)}

module.exports = {
    a,
	abbr,
	address,
	aside,
	b,
	bdi,
	bdo,
	blockquote,
	br,
	button,
	caption,
	code,
	col,
	colgroup,
	div,
	em,
	embed,
	fieldset,
	footer,
	form,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	header,
	hgroup,
	hr,
	i,
	img,
	input,
	label,
	li,
	mark,
	nav,
	ol,
	optgroup,
	option,
	p,
	pre,
	progress,
	q,
	s,
	section,
	select,
	small,
	span,
	strong,
	sub,
	sup,
	table,
	tbody,
	td,
	textarea,
	tfoot,
	th,
	thead,
	tr,
	u,
	ul, h}
